import { ChatBot } from '@activitree/chatty'
import { analytics } from '../../../../../../analytics'
import { useTranslation } from 'react-i18next'

// Import markdown files
import busSchedule from '!!raw-loader!../../../../../RacesData/goatData/aiData/busSchedule.md'
import eventGlobal from '!!raw-loader!../../../../../RacesData/goatData/aiData/event-global.md'
import distance20k from '!!raw-loader!../../../../../RacesData/goatData/aiData/distance-20k.md'
import distance35k from '!!raw-loader!../../../../../RacesData/goatData/aiData/distance-35k.md'
import distance55k from '!!raw-loader!../../../../../RacesData/goatData/aiData/distance-55k.md'
import distance100k from '!!raw-loader!../../../../../RacesData/goatData/aiData/distance-100k.md'
import distance170k from '!!raw-loader!../../../../../RacesData/goatData/aiData/distance-170k.md'

export default function Chatty ({ distance }) {
  const { t } = useTranslation('raceGuide')

  // Build the system prompt with race data
  function buildSystemPrompt(distance) {
    // Validate distance
    const validDistances = [20, 35, 55, 100, 170]
    if (distance !== undefined && distance !== null && !validDistances.includes(distance)) {
      console.warn(`Invalid distance: ${distance}, ignoring`)
      distance = null
    }

    // Always include busSchedule and event-global
    const busScheduleContent = busSchedule
    const eventGlobalContent = eventGlobal

    // Determine which distance files to use
    let distanceContent = ''
    if (distance !== undefined && distance !== null) {
      // Handle distance as integer (20, 35, 55, 100, 170)
      const distanceMap = {
        20: distance20k,
        35: distance35k,
        55: distance55k,
        100: distance100k,
        170: distance170k
      }

      distanceContent = distanceMap[distance] || ''
    } else {
      // If no distance is provided, include all distance files
      const allDistanceContents = [
        { name: '20K', content: distance20k },
        { name: '35K', content: distance35k },
        { name: '55K', content: distance55k },
        { name: '100K', content: distance100k },
        { name: '170K', content: distance170k }
      ]

      for (const { name, content } of allDistanceContents) {
        distanceContent += t('chatty.distanceGroupHeader', { name }) + content + '\n\n'
      }
    }

    const distanceLine = distance ? t('chatty.distanceLine', { distance }) : ''

    return t('chatty.systemPrompt', {
      distanceLine,
      distanceContent,
      busScheduleContent,
      eventGlobalContent
    })
  }

  const systemPrompt = buildSystemPrompt(distance)
  // const userPrompt = 'Hello, I\'m a participant in the G.O.A.T. race. Can you help me with information about the event?'

  const analyticsCallback = (event, payload) => {
    analytics.track(event, payload)
  }

  const apiUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3002/chat' : '/.netlify/functions/chat'

  // TODO: Pass styling of the chat window via the options prop
  return (
    <ChatBot
      { ...{
      systemPrompt,
      apiUrl,
      analyticsCallback,
      initialMessage: t('chatty.initialMessage'),
      chatTitle: t('chatty.chatTitle'),
      chatAvatar: '',
      options: {},
      chatName: t('chatty.chatName')
    } }
    />
  )
}
